import { render } from "./Auditoria.vue?vue&type=template&id=861353be"
import script from "./Auditoria.vue?vue&type=script&lang=js"
export * from "./Auditoria.vue?vue&type=script&lang=js"
script.render = render

export default script